import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { BRAND, COLORS } from "../../lib/brand";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    const result = await login(email.trim(), password);
    setBusy(false);
    if (result.ok) {
      navigate("/admin", { replace: true });
    } else {
      setError(result.error || "Login failed");
    }
  }

  return (
    <div
      className="min-h-[80vh] flex items-center justify-center px-4 py-16"
      style={{ background: `linear-gradient(135deg, ${COLORS.maroonDeep} 0%, ${COLORS.maroon} 100%)` }}
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 border-t-4" style={{ borderColor: COLORS.gold }}>
        <div className="flex flex-col items-center mb-6">
          <img src={BRAND.logoUrl} alt="India's Inking" className="w-20 h-20 rounded-full object-cover border-2 border-[#D4AF37] mb-3" />
          <h1 className="text-2xl font-semibold text-[#1A1A1A]">Command Center</h1>
          <p className="text-sm text-[#5C5C5C] mt-1">India's Inking Service · Admin</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="block text-xs uppercase tracking-wider text-[#5C5C5C] mb-1">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-[#E8E2D5] rounded-md focus:outline-none focus:border-[#800000] focus:ring-1 focus:ring-[#800000]"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-[#5C5C5C] mb-1">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-[#E8E2D5] rounded-md focus:outline-none focus:border-[#800000] focus:ring-1 focus:ring-[#800000]"
              data-testid="admin-login-password"
            />
          </div>
          {error && <div className="text-sm text-[#800000]" data-testid="admin-login-error">{error}</div>}
          <button
            type="submit"
            disabled={busy}
            className="w-full py-3 rounded-md text-white font-medium tracking-wide transition disabled:opacity-60"
            style={{ background: COLORS.maroon }}
            onMouseEnter={(e) => (e.currentTarget.style.background = COLORS.maroonHover)}
            onMouseLeave={(e) => (e.currentTarget.style.background = COLORS.maroon)}
            data-testid="admin-login-submit"
          >
            {busy ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
